import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchStockTakeActive = createAsyncThunk(
  "fetchStockTakeActive",
  async () => {
    const token = localStorage.getItem("auth_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };


    const response = await axiosHttp.get(
      `stock-take/active`,
      config
    );

    return response.data.data;
  }
);

const stockTakeActiveSlice = createSlice({
  name: "stockTakeActive",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
    page: 1,
    total: 0,
  },

  extraReducers: (builder) => {
    builder.addCase(fetchStockTakeActive.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(fetchStockTakeActive.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.page = action.payload.page;
      state.total = action.payload.total;
    });
    builder.addCase(fetchStockTakeActive.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default stockTakeActiveSlice.reducer;
